import { useNavigate } from 'react-router-dom';

import { authService } from '@/services/auth.service';
import { useAlertContext } from '@/contexts/alert.context';
import { useErrorHandler } from '@/shared/hooks/useErrorHandler';

export type RecoverPasswordFormData = {
  email: string;
};

export function useRecoverPassword() {
  const navigation = useNavigate();

  const { notify } = useAlertContext();
  const { handleError } = useErrorHandler();

  const onSubmit = async ({ email }: RecoverPasswordFormData) => {
    try {
      await authService.requestPasswordRecovery(email);
      
      notify({
        message: 'Email de recuperação enviado com sucesso! Verifique sua caixa de entrada.',
        type: 'success',
      });
    } catch (error) {
      handleError(error);
    }
  };

  const backToLogin = () => {
    navigation('/login');
  };

  return {
    onSubmit,
    backToLogin,
  };
}
